import {Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../../../core/utils/utils.service";
import {FermeturePonctuelleSavedSupplier, FermeturePoncutelleService} from "../../../core/services/entities/fermeture-poncutelle.service";
import {FermeturePonctuelleDTO} from "../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {combineLatest, Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {UniteDeProductionDTO} from "../../../core/dtos/unite-de-production-dto";
import {confirm} from "devextreme/ui/dialog";
import {ResponseWrapper} from "../../../core/suppliers/wrappers/response-wrapper";
import {IsDeletableObject} from "../../../core/models/is-deletable-object";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {FermeturePonctuelleFilter} from "../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleFilter";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-up-fermetures-ponctuelles',
  templateUrl: './up-fermetures-ponctuelles.component.html',
  styleUrls: ['./up-fermetures-ponctuelles.component.scss'],
  standalone: false
})
export class UpFermeturesPonctuellesComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  fermeturePonctuelleSavedSub: Subscription;
  subRoute: Subscription;
  deleteSub: Subscription;
  selectedRows: number[] = [];

  data: FermeturePonctuelleDTO[] = [];
  uniteProduction: UniteDeProductionDTO;

  constructor(public utilsSvc: UtilsService,
              private fermeturePonctuelleSvc: FermeturePoncutelleService,
              private route: ActivatedRoute,
              private i8nSvc: InternationalizationService,
              public toastSvc: ToastService
  ) {
  }

  ngOnInit(): void {
    this.initData();
    this.initPointFacturationSavedSubscription();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.fermeturePonctuelleSavedSub);
    this.utilsSvc.unsubscribe(this.subRoute);
    this.utilsSvc.unsubscribe(this.deleteSub);
  }

  initData = (): void => {
    const all$ = combineLatest([this.route.parent.data]);
    this.subRoute = all$.subscribe(data => {
      this.uniteProduction = data[0].uniteDeProductionSupplier.uniteDeProduction;
      const filter = new FermeturePonctuelleFilter();
      filter.idUniteProduction = this.uniteProduction.id;
      this.fermeturePonctuelleSvc.getFermeturePonctuelle(filter).subscribe(result => {
        this.data = result;
      });
    });
  }

  openDialogEdition = (fermeturePonctuelle: FermeturePonctuelleDTO): void => {
    console.log(fermeturePonctuelle)
    this.fermeturePonctuelleSvc.announceOpenDialogEdition(fermeturePonctuelle);
  };

  initPointFacturationSavedSubscription = (): void => {
    this.fermeturePonctuelleSavedSub = this.fermeturePonctuelleSvc.fermeturePonctuelleSaved
      .subscribe((response: FermeturePonctuelleSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.data.findIndex(fermeturePonctuelle => fermeturePonctuelle.id === response.fermeturePonctuelle.id);
          this.data[idx] = response.fermeturePonctuelle;
        } else {
          this.data.push(response.fermeturePonctuelle);
        }
      });
  };

  canDelete = (): boolean => this.selectedRows.length > 0;

  deleteValues = async (): Promise<void> => {
    let idsToDeleteInTable = Object.assign([], this.selectedRows);
    const isDeletionValidated: boolean = await confirm(this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? 'CONFIRM_DELETION_PLURAL' : 'CONFIRM_DELETION_SINGULAR', null), this.i8nSvc.getLabelFromCode('Suppression', null));
    if (!isDeletionValidated) {
      return new Promise(null);
    }

    this.deleteSub = this.fermeturePonctuelleSvc.deleteFermeturePonctuelleByFilters(this.selectedRows).subscribe(response => {
      const res: any = (response as ResponseWrapper<IsDeletableObject>).one;

      if (res) {
        if (res.messagesErrorList && res.messagesErrorList.length > 0) {
          for (const error of res.messagesErrorList) {
            const elementToKeep = this.data.find(fermeture => fermeture.code === error.args);
            idsToDeleteInTable = idsToDeleteInTable.filter(id => elementToKeep.id !== id);
          }
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? `DELETION_COMPLETED_PLURAL` : `DELETION_COMPLETED_SINGULAR`, null));
        }
        this.data = this.data.filter(fermeture => !idsToDeleteInTable.find(id => id === fermeture.id));
      }
    });
  }


}
